// extracted by mini-css-extract-plugin
module.exports = {"wallet":"balance-block_wallet__1sLku","balanceValue":"balance-block_balanceValue__1czIG","balanceUcd":"balance-block_balanceUcd__2TaMr"};